// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-42db63eb].ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{width:52px !important;margin-bottom:10px;margin-right:9px !important}.pro .tips[data-v-42db63eb]{height:50px;line-height:50px;color:#999;font-size:12px;border-bottom:1px solid rgba(0,0,0,.05)}.btn-box[data-v-42db63eb]{padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
